// removed by extract-text-webpack-plugin
module.exports = {"container":"_3cVrVd2","suggestionsContainer":"rKZtiIO","containerOpen":"_2AeY2Fd","suggestionsContainer_withLabel":"_2EuqlnO","sectionTitle":"_2T9S4Xs","sectionContainer":"_172YDos","suggestion":"_2YQtnJw","suggestionFocused":"_3E-HAh_"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/fields/Autosuggest/Autosuggest.less
 ** module id = 675
 ** module chunks = 0
 **/